<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/11.png"
			alt="" />
<div class="title" style="margin-top: 40px;margin-bottom: 15px;">规模化养殖的痛点</div>
<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/0eaa171c-5637-4832-8f17-66a1e077bb8b.png" style="width: 80%;" alt="" />

		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">智慧养殖基地建设方案</div>
		<div class="desc" style="margin-top: 20px;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广积粮智慧养殖服务系统通过 “监、管、控、溯”
			一体化，实现对养殖全过程的数字化管理。核心功能可概括为以下四点：<br />
			<h4 style="margin: 5px 0;">环境智能监控：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：通过物联网传感器，实时监测 并自动调控舍内温度、湿度、氨气、光照等环境参数。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：为畜禽创造最佳生长环境，减少应激与疾病。<br />
			<h4 style="margin: 5px 0;">精准饲喂管理：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：基于生长模型，实现定时、定量、定料的自动精准投喂，并实时监控采食量与饮水情况。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：显著提高饲料转化率，降低料肉比，节约成本。<br />
			<h4 style="margin: 5px 0;">健康与安全监管：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：利用视频AI分析
			畜禽行为（如趴卧、争斗），实时预警疫病风险；通过电子耳标等实现个体身份溯源与档案管理。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：实现疾病早发现、早预警，提升生物安全水平。<br />
			<h4 style="margin: 5px 0;">数据决策与溯源：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：集中管理 所有生产、环境、健康数据，生成可视化报表；并建立从养殖到销售的全程质量追溯体系。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：为经营决策提供数据支撑，为产品安全提供信任背书。<br /><br />
			广积粮智慧养殖系统是养殖基地的“智能中枢”，旨在实现生产全过程的可视、可控、可管、可溯，最终达到降本、增效、优质和安全的目标。
		</div>
		<!-- <div class="title" style="margin-top: 40px;margin-bottom: 15px;">方案5大优势</div> -->
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/2.png"
			alt="" />

		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">标准化养殖</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/1.png"
			alt="" />
			<div class="title" style="margin-top: 40px;margin-bottom: 15px;">标准化软件产品优势</div>
			<div class="title-desc">网页版+手机APP，随时随地无忧管理</div>
			<div class="flex alit">
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/5.png" style="width: 20vw;height: 50vh;" alt="" />
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/21.png" alt="" style="width: 50vw;height: 60vh;" />
			</div>

		<video style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%BB%E6%AE%96/%E5%85%9411.4.m4v"
			controls></video>
		<!-- <img style="width: 80%;margin: 10px 0;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1.png"
			alt="" /> -->
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 80%;
		font-size: 24px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
		color: rgb(86 146 48);
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>